import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-uploadcontent',
  templateUrl: './uploadcontent.component.html',
  styleUrls: ['./uploadcontent.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class UploadcontentComponent {
  @Input() file: File | { name: string } = { name: '' };
  @Input() showRemoveButton: boolean = true;
  @Output() removeFile = new EventEmitter<void>();

  getFileType(): string {
    if (!this.file || !this.file.name.includes('.')) return 'Unknown';
    const fileType = this.file.name.split('.').pop()?.toLowerCase() || '';
    if (['xls', 'xlsx', 'csv', 'ods'].includes(fileType)) return 'Spreadsheet';
    if (['pdf'].includes(fileType)) return 'PDF';
    if (['doc', 'docx', 'odt'].includes(fileType)) return 'Document';
    return 'File';
  }

  getFileIcon(): string {
    const fileType = this.getFileType();
    if (fileType === 'Spreadsheet') return 'assets/custom-icons/spreadsheet.svg';
    return 'assets/custom-icons/document.svg';
  }

  getFileBackgroundColor(): string {
    const fileType = this.getFileType();
    if (fileType === 'Spreadsheet') return '#10A37F';
    return '#FF5588';
  }

  onRemoveFile(): void {
    this.removeFile.emit();
  }
}
